import { Box } from "@mui/material";
import Link from "next/link";
import { useId } from "react";
import { useTranslation } from "react-i18next";
import { SITE_WRAP } from "src/domains/shared/constants/styles/site";
import { ClosingContact } from "../siteKit/ClosingContact";
import { EducationCards } from "../siteKit/EducationCards";
import { SiteImage } from "../siteKit/media/SiteImage";
import { PageHero } from "../siteKit/PageHero";
import { PartnersStrip } from "../siteKit/PartnersStrip";
import { SectionHead } from "../siteKit/SectionHead";
import { SiteSection } from "../siteKit/SiteSection";
import { ServiceFlow } from "../siteKit/ServiceFlow";
import { SITE_BUTTON_STYLES } from "../siteKit/siteButtonStyles";
import { SiteTitle } from "../siteKit/SiteText";
import { SurveyResults } from "./SurveyResults";

/** 드론 측량 및 공간 데이터 가공(`/survey`, marketing-service-pages) — 시안 survey.html 그대로. */
export function SurveyPage() {
  const { t } = useTranslation("landing");
  const processTitleId = useId();
  return (
    <>
      <PageHero
        eyebrow={t("site.survey.eyebrow")}
        title={t("site.survey.title")}
        description={t("site.survey.description")}
        actions={
          <Box
            component={Link}
            href="/inquiry"
            sx={SITE_BUTTON_STYLES.primaryLarge}
          >
            {t("site.survey.ask")}
          </Box>
        }
        media={
          <SiteImage
            name="drone_forest2"
            sizes="(max-width: 1272px) 100vw, 1224px"
            alt={t("site.survey.heroAlt")}
            priority
            placeholder="blur"
            style={{ objectPosition: "50% 45%" }}
          />
        }
      />
      <SiteSection labelledBy={processTitleId}>
        <Box sx={SITE_WRAP}>
          <SectionHead
            titleId={processTitleId}
            eyebrow={t("site.survey.process.eyebrow")}
            title={t("site.survey.process.title")}
          />
          <ServiceFlow withDescriptions />
        </Box>
      </SiteSection>
      <SurveyResults />
      <EducationCards />
      <PartnersStrip />
      <ClosingContact
        eyebrow={t("site.survey.closing.eyebrow")}
        title={<SiteTitle text={t("site.survey.closing.title")} />}
        actions={
          <>
            <Box
              component={Link}
              href="/accurate"
              sx={SITE_BUTTON_STYLES.primaryLarge}
            >
              {t("site.survey.closing.more")}
            </Box>
            <Box
              component={Link}
              href="/inquiry"
              sx={SITE_BUTTON_STYLES.outlineLarge}
            >
              {t("site.survey.closing.ask")}
            </Box>
          </>
        }
      />
    </>
  );
}
